module.exports = __webpack_public_path__ + "img/fondo_series.e3872063.svg";